class ActivitiesFocusBox extends HTMLElement {
  constructor() {
    super();
    this.allSlides = [];
    this.handleResizeBound = this.handleResize.bind(this);
  }

  connectedCallback() {
    this.init();
    window.addEventListener("resize", this.handleResizeBound);
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResizeBound);
  }

  init() {
    const components = [...this.querySelectorAll("[data-component='activities-focus-box']")];

    components.forEach((component, index) => {
      const slides = [...component.querySelectorAll("[data-item='slide']")];
      this.allSlides.push(...slides);
      const radioButtons = [...component.querySelectorAll("[data-item='radio-button']")];
      const groupName = `radio-group-${index}`;

      radioButtons.forEach((radio, idx) => {
        radio.setAttribute("name", groupName);
        if (idx === 0) radio.checked = true;
        radio.addEventListener("change", () => radio.checked && this.updateSlideVisibility(slides, idx));
      });

      slides.forEach((slide, idx) => {
        slide.classList.add("hidden", "opacity-0");
        if (idx === 0) this.showSlide(slide);
      });
    });
    this.updateSlidesForScreenSize();
  }

  handleResize() {
    this.updateSlidesForScreenSize();
  }

  updateSlidesForScreenSize() {
    if (window.matchMedia("(max-width: 1024px)").matches) {
      this.allSlides.forEach((slide) => {
        slide.classList.remove("hidden");
        slide.classList.add("opacity-100");
      });
      if (this.allSlides.length === 1) {
        this.allSlides[0].classList.remove("flex-shrink-0", "w-full");
      }
    } else {
      this.allSlides.forEach((slide, idx) => {
        if (idx !== 0) {
          slide.classList.add("hidden");
          slide.classList.remove("opacity-100");
        }
      });
    }
  }

  showSlide(slide) {
    slide.classList.replace("hidden", "opacity-100");
  }

  updateSlideVisibility(slides, newIndex) {
    const [currentSlide, newSlide] = [slides.find((s) => !s.classList.contains("hidden")), slides[newIndex]];
    if (currentSlide) {
      currentSlide.classList.replace("opacity-100", "opacity-0");
      currentSlide.addEventListener(
        "transitionend",
        () => {
          currentSlide.classList.add("hidden");
          this.showSlide(newSlide);
        },
        { once: true }
      );
    }
  }
}

customElements.define("activities-focus-box", ActivitiesFocusBox);
